import { render, staticRenderFns } from "./exchange_detail.vue?vue&type=template&id=6c87b4e5&scoped=true&"
import script from "./exchange_detail.vue?vue&type=script&lang=js&"
export * from "./exchange_detail.vue?vue&type=script&lang=js&"
import style0 from "./exchange_detail.vue?vue&type=style&index=0&id=6c87b4e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87b4e5",
  null
  
)

export default component.exports